import typeOf from '../typeOf.js';

const type = 'object';

export default {
  type: type,
  is: function (value) {
    return typeOf(value) === type;
  },
  isNot: function (value) {
    return typeOf(value) !== type;
  },
  isNotEmpty: function (value) {
    return Object.keys(value).length > 0;
  }
}